import { changeColorLightness } from '../../../shared/styles/utils';

const placeholderStyle = {
  fontFamily: 'Gilroy',
  color: '#787B80',
  fontSize: 12
};

const withPlaceholder = {
  '& input::placeholder': placeholderStyle,
  '& input:-ms-input-placeholder': placeholderStyle,
  '& input::-ms-input-placeholder': placeholderStyle,
  '& textarea::placeholder': placeholderStyle,
  '& textarea:-ms-input-placeholder': placeholderStyle,
  '& textarea::-ms-input-placeholder': placeholderStyle
};

export const modalStyles = {
  paper: {
    width: 600,
    borderRadius: 8,
    '& .MuiDialogContent-root': { padding: 0 },
    '& .MuiDialogTitle-root': { margin: '8px 0px' }
  },
  wizardButtons: { height: 40, minWidth: 84 },
  buttonsContainer: { borderTop: '1px solid #E5E7E8', padding: '12px 24px' }
};

export const textFieldStyles = {
  decorationEditSection: ({ compactStyle }) => ({
    paddingTop: compactStyle ? 0 : 12,
    paddingBottom: 12,
    borderBottom: compactStyle ? 0 : '1px solid #E8E9EB',
    width: '100%',
    ...withPlaceholder
  }),
  tip: {
    ...placeholderStyle,
    marginLeft: 16
  },
  label: ({ compactStyle, disabled }) => ({
    fontFamily: 'Gilroy',
    color: disabled ? '#989EA4' : '#787B80',
    fontSize: 14,
    marginBottom: compactStyle ? 12 : 12,
    marginTop: compactStyle ? 12 : 12
  }),
  inputText: {
    width: '100%',
    '& input': {
      padding: 0,
      borderRadius: '0px !important',
      minWidth: 216
    },
    '& input::placeholder': {
      fontStyle: 'italic'
    },
    '& fieldset': {
      borderRadius: '0px',
      border: '1px solid transparent !important'
    }
  },
  longInputText: {
    width: '100%',
    '& .MuiInputBase-formControl': {
      minHeight: 120,
      padding: '10px 22px'
    },
    '& .MuiOutlinedInput-notchedOutline': {
      borderRadius: 15
    },
    '& textarea': {
      minHeight: 85
    }
  },
  addButton: {
    height: 40,
    paddingTop: 0,
    paddingBottom: 0
  },
  delete: {
    fontFamily: 'Gilroy',
    color: '#3577D4',
    fontSize: 24
  },
  valueText: ({ disabled }) => ({
    color: disabled ? '#989EA4' : '#000000',
    fontFamily: 'Gilroy',
    fontSize: 14,
    marginTop: 8
  })
};

export default {
  header: {
    fontFamily: 'Gilroy',
    fontSize: 16,
    fontWeight: 'bold',
    color: '#000000'
  },
  logoFileName: {
    color: '#787B80',
    fontFamily: 'Gilroy',
    fontSize: 10,
    marginLeft: 16,
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap'
  },
  uploadIcon: {
    height: 32,
    width: 32
  },
  link: {
    color: '#3577D4',
    fontFamily: 'Gilroy',
    fontSize: 14,
    fontWeight: 'bold'
  },
  uploadText: ({ disabled }) => ({
    color: disabled ? '#989EA4' : '#0B1829',
    fontFamily: 'Gilroy',
    fontSize: 14,
    fontWeight: 600
  }),
  logoName: {
    color: '#787B80',
    fontFamily: 'Gilroy',
    fontSize: 14
  },
  replace: {
    fontFamily: 'Gilroy',
    fontSize: 14,
    fontWeight: 'bold',
    cursor: 'pointer',
    color: ({ disabled }) => (disabled ? '#787b80' : '#3577D4')
  },
  colorList: ({ disabled }) => ({
    '& p': {
      color: disabled ? '#989EA4' : '#000000',
      fontFamily: 'Gilroy',
      fontSize: 16,
      marginTop: 8
    }
  }),
  decorationEditSection: {
    paddingTop: 12,
    paddingBottom: 12,
    borderBottom: '1px solid #E8E9EB',
    width: '100%'
  },
  logoContainer: {
    height: '136px',
    width: 'inherit',
    objectFit: 'contain',
    padding: '20px',
    borderRadius: 'inherit'
  },
  logo: {
    height: '100%',
    objectFit: 'contain',
    width: 'inherit'
  },
  fileFormats: ({ disabled }) => ({
    color: disabled ? '#989EA4' : '#787B80',
    fontFamily: 'Gilroy',
    fontSize: 12,
    textAlign: 'center',
    padding: '5px 0px',
    fontWeight: 400
  }),
  ImageUploadContainer: {
    height: 100,
    borderRadius: 10,
    width: 'inherit',
    backgroundImage: `url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='10' ry='10' stroke='%23E5E7E8FF' stroke-width='4' stroke-dasharray='11' stroke-dashoffset='0' stroke-linecap='square'/%3e%3c/svg%3e")`
  },
  imprintType: ({ disabled }) => ({
    fontFamily: 'Gilroy',
    color: disabled ? '#989EA4' : '#787B80',
    fontSize: 14,
    marginBottom: 12,
    marginTop: 12
  }),
  imprintTypeValue: ({ disabled }) => ({
    fontFamily: 'Gilroy',
    color: disabled ? '#989EA4' : '#787B80',
    fontSize: 14,
    marginBottom: 0
  }),
  delete: {
    fontFamily: 'Gilroy',
    color: '#3577D4',
    fontSize: 24
  },
  bottomSpacing: {
    width: '100%',
    height: 56
  },
  wizardButtons: ({ backgroundColor }) => ({
    height: 40,
    minWidth: 84,
    backgroundColor,
    '&:hover': { backgroundColor: changeColorLightness(backgroundColor || '#3577d4') }
  }),
  declineButton: ({ color }) => ({
    color,
    '&:hover': { color: changeColorLightness(color || '#3577d4') }
  }),
  addRequestButton: {
    color: '#3577d4',
    '&:hover': { color: changeColorLightness('#3577d4') }
  },
  deleteWizardButtons: {
    cursor: 'Pointer',
    color: '#C62828',
    fontWeight: 400
  },
  panelBody: {
    display: ({ uploadWarning, deleteWarning }) => (uploadWarning || deleteWarning ? 'block' : 'contents'),
    position: 'relative'
  },
  newWindow: {
    paddingBottom: '2px !important'
  },
  notesWrapper: { paddingTop: 12, paddingBottom: 12, width: '100%' },
  modalPopup: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 600,
    backgroundColor: '#ffffff',
    borderRadius: '8px',
    height: 'max-content',
    wordWrap: 'break-word',
    padding: 20,
    paddingBottom: 0,
    border: 0
  },
  cancelBtn: {
    color: '#3577D4',
    fontWeight: 600,
    textAlign: 'center',
    cursor: 'pointer'
  },
  deleteBtn: {
    '&:hover': {
      backgroundColor: '#F44336',
      boxShadow: 'none',
      color: '#ffffff',
      borderColor: '#F44336'
    },
    backgroundColor: '#F44336',
    color: '#ffffff',
    minWidth: '100px !important',
    fontWeight: 600,
    cursor: 'pointer',
    borderColor: '#F44336'
  },
  chipContainer: {
    width: '100%'
  },
  chipBox: {
    height: 48,
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    backgroundColor: '#E5E7E8',
    paddingRight: 12,
    '& span': {
      fontSize: 14,
      color: '#4A4F54',
      fontWeight: 400
    },
    '& svg': {
      color: '#4A4F54'
    }
  },
  shareLogo: {
    height: 22,
    objectFit: 'contain',
    width: 22
  },
  continueBtn: {
    color: '#3577D4',
    fontWeight: 600,
    textAlign: 'center',
    cursor: 'pointer'
  },
  iconWrapper: {
    padding: '0px 20px',
    width: '20%'
  },
  closebtn: {
    color: '#131415'
  },
  mainAccordian: {
    borderRadius: '0px !important',
    borderBottom: '1px solid #E5E7E8',
    boxShadow: 'none',
    padding: '10px 0px !important'
  },
  summaryAccordian: {
    padding: '0px !important',
    '& div': {
      margin: '0px !important',
      padding: '0px !important'
    }
  },
  imgContainer: {
    display: 'flex',
    justifyContent: 'space-between'
  }
};
